import React from 'react';

import { Banner } from './header/banner';
import TopBar from './header/TopBar';
import HomeQuickLinks from './HomeQuickLinks';
import './Home.css';


const Accueil = () => (
  <main className="content2 home-page">
    <Banner />
    <TopBar />
    <HomeQuickLinks />
  </main>
);

export default Accueil
